import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const data = {
  title: 'Google',
  subtitle: 'Ads (PPC)',
  tagline: 'Be at the Top of Google',
  icon: '',
  // icon: '🎯',

  heroDesc: 'Drive high-intent traffic directly to your business with expertly managed Google Ads campaigns. We ensure every rupee you spend delivers maximum return on investment.',
  mainStat: '4x',
  mainStatLabel: 'Average ROI for our Google Ads clients',
  subStats: [{ value: '300+', label: 'Campaigns Run' }, { value: '40%', label: 'Lower CPA on Avg' }],
  features: [
    { icon: '🔍', title: 'Search Ads', desc: 'Appear at the top of Google when customers search for your services.' },
    { icon: '🖼️', title: 'Display Advertising', desc: 'Visually compelling banner ads across Google\'s massive display network.' },
    { icon: '🛒', title: 'Shopping Ads', desc: 'Showcase your products directly in Google search results.' },
    { icon: '▶️', title: 'YouTube Ads', desc: 'Video advertising to reach your audience on the world\'s biggest video platform.' },
    { icon: '🔄', title: 'Remarketing', desc: 'Re-engage visitors who showed interest but didn\'t convert.' },
    { icon: '📊', title: 'Conversion Tracking', desc: 'Complete analytics setup to track every lead and sale generated.' },
  ],
  benefits: [
    { title: 'Immediate Visibility', desc: 'Appear on page one of Google within hours of campaign launch.' },
    { title: 'Highly Targeted Traffic', desc: 'Reach exactly the right people based on keywords, location, and intent.' },
    { title: 'Measurable ROI', desc: 'Track every click, lead, and sale with precision analytics.' },
    { title: 'Scalable Budget Control', desc: 'Start small and scale as you see results — full budget control always.' },
  ],
  process: [
    { title: 'Account Audit & Research', desc: 'Thorough keyword research, competitor analysis, and account structure planning.' },
    { title: 'Campaign Setup', desc: 'Professional campaign structure with tightly themed ad groups and quality scores.' },
    { title: 'Ad Copy & Creative', desc: 'Compelling ads written and designed to maximize click-through rates.' },
    { title: 'Launch & Monitor', desc: 'Campaigns launched with close monitoring in the first 72 hours.' },
    { title: 'Optimize & Scale', desc: 'Continuous A/B testing, bid optimization, and budget scaling for better ROI.' },
  ],
  whyChoose: [
    { icon: '🎓', title: 'Google Certified', desc: 'Our team holds Google Ads certifications for search, display, and shopping.' },
    { icon: '📊', title: 'Transparent Reporting', desc: 'Weekly and monthly reports showing exact performance and spend.' },
    { icon: '🔬', title: 'Data-Led Decisions', desc: 'Every optimization is backed by data, not intuition.' },
    { icon: '💰', title: 'No Budget Waste', desc: 'Negative keywords, quality scores, and bid strategies minimize wasted spend.' },
  ],
  reviews: [
    { name: 'Prakash Gupta', role: 'Clinic Owner', text: 'We went from 0 to 50 patient inquiries per month in just 2 months with DMS Google Ads.' },
    { name: 'Meera Shah', role: 'E-Commerce Store', text: 'Our Google Shopping ads have a 6x ROAS. DMS has been an incredible investment.' },
    { name: 'Rajesh Nair', role: 'Real Estate Developer', text: 'The lead quality from Google Ads managed by DMS is far superior to any other channel.' },
  ],
  faq: [
    { q: 'What budget do I need for Google Ads?', a: 'We work with budgets starting from ₹10,000/month. We\'ll recommend the right budget based on your industry and goals.' },
    { q: 'How quickly will I see results?', a: 'You can start getting traffic and leads from day one. Optimal performance is typically achieved within 30–90 days of optimization.' },
    { q: 'Do you charge a management fee?', a: 'Yes, we charge a transparent management fee separate from your ad spend. Contact us for current pricing.' },
  ],
};

export default function GoogleAds() {
  return <ServiceTemplate data={data} />;
}
